import React, { useState, useContext } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Sales from '../Sales/Sales';
import Alert from '@ldm/alert';
import WarningIcon from '../../assets/icons/warning.svg';
import CloseIcon from '../../assets/icons/close.svg';
import { ThemeProvider } from '@ldm/theme';
import { UserPortalContext } from '../../context/appcontext';
import { useDispatch, useSelector } from 'react-redux';
import { CATMANVIEW } from '../../constants/constant';
import Notifications from '../CustomAlert/NotificationList/Notifications';
import {
	putNotificationsRead,
	setIsNotificationOpen,
} from '../../redux/actions/createRuleActions';
import {
	setIsDrawerOpen,
	setIsMetricsOpen,
} from '../../redux/actions/customTableColumnAction';
import BusinessHierarchy from '../Filter/BusinessHierarchy';
import { saveFirstTimeUserStatus } from '../../redux/actions/appGuideActions';
import TourGuide, { ACTIONS, EVENTS, STATUS, LAST_INDEX } from '../TourGuide';
function NewHeaders() {
	const dispatch = useDispatch();
	// To track Tour guide steps
	const [tourGuideStepIndex, setTourGuideStepIndex] = useState(0);
	const [showWarning, setShowWarning] = useState(true);

	const selectedFilters = useSelector(
		(state) => state.salesReducer.selectedFilters
	);
	const { isFirstTimeUser } = useSelector((state) => state.appGuideReducer);

	const sessionWeekFilters = JSON.parse(sessionStorage.getItem('weekfilters'));

	const { weekFilter, startDate, endDate } =
		sessionWeekFilters && Object.keys(sessionWeekFilters)?.length != 0
			? sessionWeekFilters
			: selectedFilters;

	const portalUserContext = useContext(UserPortalContext);

	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	const CustomWarningIcon = () => (
		<img src={WarningIcon} alt="Warning Message" />
	);
	const CustomCloseIcon = () => <img src={CloseIcon} alt="Close" />;

	//const matches = useMediaQuery('(max-width:960px)');

	const onNotificationClose = () => {
		dispatch(setIsNotificationOpen(false));
		// Dispatch Put notification read
		dispatch(putNotificationsRead({ portalUserContext }));
	};

	/**
	 * This callback gets invoked on every action on the Tour guide tooltip (Joyride)
	 * This way of showing Tour guide is called Controlled method.
	 */
	const tourGuideCallback = (data) => {
		const { action, index, status, type } = data;

		if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
			// Need to set our running state to false, so we can restart if we click start again.
			setTourGuideStepIndex(0);

			// In final step, while clicking on Done the drawer & metrics should close
			dispatch(setIsDrawerOpen(false));
			dispatch(setIsMetricsOpen(false));

			if (STATUS.FINISHED === status) {
				// When Tour guide is finished, trigger the API call to update status
				dispatch(saveFirstTimeUserStatus({ portalUserContext }));
			}
		} else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
			// Next step index
			const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1);

			// Before the final step, the Drawer & Metrics should open by default, and then Tour guide is shown after a delay
			if (index === LAST_INDEX) {
				dispatch(setIsDrawerOpen(true));
				dispatch(setIsMetricsOpen(true));
				// eslint-disable-next-line no-undef
				setTimeout(() => setTourGuideStepIndex(nextStepIndex), 400);
			} else {
				setTourGuideStepIndex(nextStepIndex);
			}
		}
	};

	return (
		<>
			<Grid container>
				<Box sx={{ width: '100%' }}>
					<Grid item>
						{selectedView === CATMANVIEW && showWarning ? (
							<Box
								sx={{
									marginRight: '13px',
									marginLeft: '14px',
								}}>
								<ThemeProvider>
									<Alert
										components={{
											AlertWarningIcon: CustomWarningIcon,
											AlertCloseIcon: CustomCloseIcon,
										}}
										variant="warning"
										onClose={() => setShowWarning(false)}>
										Due to large volume of data, custom time window selection
										may result in longer load times.
									</Alert>
								</ThemeProvider>
							</Box>
						) : null}

						<Sales
							weekFilter={weekFilter}
							startDate={startDate}
							endDate={endDate}
						/>
					</Grid>
				</Box>
				<BusinessHierarchy />
			</Grid>

			{/* Notifications w/ Drawer */}
			<Notifications onClose={onNotificationClose} />

			{/* Tour Guide on Dashboard */}
			<TourGuide
				open={isFirstTimeUser}
				stepIndex={tourGuideStepIndex}
				tourGuideCallback={tourGuideCallback}
			/>
		</>
	);
}

export default NewHeaders;
